/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-env jquery */

import { Component, registerComponent } from 'js/component.js';

const componentName = 'product-recommendations';
const productDetailServletEndpoint = '/bin/rockwell-automation/product-details';
const productDetailsPage = '/products/details.';
class ProductRecommendations extends Component {
    elements = {
        container: this.element.querySelector(`.${componentName}__container`),
        productTemplate: this.element.querySelector(`.${componentName}__product-template`),
        basedOnViewsList: this.element.querySelector(`.${componentName}__content--based-on-views .${componentName}__products`),
        bestSellingList: this.element.querySelector(`.${componentName}__content--best-selling .${componentName}__products`),
    };

    constants = {
        productsToDisplay: 4,
        defaultImage: 'https://www.rockwellautomation.com/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/image_unavailable.svg',
        locale: document.documentElement.lang ? document.documentElement.lang.toLocaleLowerCase() : 'en-us',
        bestSellingCatalogNumbers: this.element.querySelector(`.${componentName}__content--best-selling`).dataset.catalogNumbers,
        appType: this.element.querySelector(`.${componentName}__container`).dataset.appType,
        productImagePrefix: 'https://configurator.rockwellautomation.com/api/Doc/',
        productSet: [],
    };

    getBasedOnViewsProducts = () => {
        if (!window.localStorage.getItem('pira-pz-recomms')) {
            return { productResultsBasedOnViews: [], productCategoryBasedOnViews: '' };
        }
        let recommendedPageList = [];
        try {
            recommendedPageList = JSON.parse(window.localStorage.getItem('pira-pz-recomms'));
        } catch (error) {
            console.warn('Error parsing recommended page list:', error);
        }
        const productResults = [];
        const recommendedCategories = [];
        while (recommendedPageList.length > 0 && productResults.length < this.constants.productsToDisplay) {
            const recommendedPage = recommendedPageList.shift();
            if (!recommendedPage.page || !recommendedPage.title) {
                continue;
            }
            if (recommendedPage.page.includes('/products/hardware/') && !recommendedPage.page.includes('/products/hardware/allen-bradley')) {
                productResults.push(recommendedPage);
                recommendedCategories.push(recommendedPage.page.replace('/products/hardware', '').replace('.html', ''));
            } else if (recommendedPage.page.includes('/products/hardware/allen-bradley/')) {
                productResults.push(recommendedPage);
                recommendedCategories.push(recommendedPage.page.replace('/products/hardware/allen-bradley', '').replace('.html', ''));
            } else if (recommendedPage.page.includes('/products/details.')) {
                this.constants.productSet.push(recommendedPage.page.split('/products/details.')[1].replace('.html', ''));
                productResults.push(recommendedPage);
            }
        }
        return { productResultsBasedOnViews: productResults.slice(0, this.constants.productsToDisplay), productCategoriesBasedOnViews: recommendedCategories };
    };

    getBestSellingBasedOnViews = async () => {
        if (!window.localStorage.getItem('pira-pz-recomms')) {
            return [];
        }
        let recommendedPageList = [];
        try {
            recommendedPageList = JSON.parse(window.localStorage.getItem('pira-pz-recomms'));
        } catch (error) {
            console.warn('Error parsing recommended page list:', error);
        }
        const productResults = [];
        while (recommendedPageList.length > 0 && productResults.length < this.constants.productsToDisplay) {
            const recommendedPage = recommendedPageList.shift();
            if (!recommendedPage.page) {
                continue;
            }
            if (recommendedPage.page.includes('/products/details.') && recommendedPage.best) {
                const catalogNumber = recommendedPage.page.split('/products/details.')[1].replace('.html', '');
                if (!this.constants.productSet.includes(catalogNumber)) {
                    productResults.push(recommendedPage);
                    this.constants.productSet.push(catalogNumber);
                }
            }

        }
        return productResults;
    }

    getBestSellingProducts = async () => {
        const bestSellingProducts = [];
        const locale = document.documentElement.lang ? document.documentElement.lang.toLocaleLowerCase() : 'en-us';
        const countryCode = locale.split('-')[1];

        // Get best selling products from catalog numbers
        if (this.constants.bestSellingCatalogNumbers) {
            try {
                const response = await fetch(`${productDetailServletEndpoint}?catalogNumber=${this.constants.bestSellingCatalogNumbers}&app=${this.constants.appType}&countryCode=${countryCode}`);
                const responseBuffer = await response.arrayBuffer();
                const responseString = new TextDecoder('UTF-8').decode(responseBuffer);
                const responseJson = JSON.parse(responseString);
                if (responseJson.length) {
                    responseJson.forEach((product) => {
                        bestSellingProducts.push({
                            title: product.names_value || product.title,
                            description: product.description || product.R_description,
                            imageUrl: product.picture_url || this.constants.defaultImage,
                            page: productDetailsPage + product.catalogNumber + '.html',
                        });
                        this.constants.productSet.push(product.catalogNumber);
                    });
                } else {
                    bestSellingProducts.push({
                        title: responseJson.names_value || responseJson.title,
                        description: responseJson.description || responseJson.R_description,
                        imageUrl: responseJson.picture_url || this.constants.defaultImage,
                        page: productDetailsPage + responseJson.catalogNumber + '.html',
                    });
                    this.constants.productSet.push(responseJson.catalogNumber);
                }
            } catch (error) {
                console.warn('Error fetching best selling products:', error);
            }
        }

        const numRemainingProducts = this.constants.productsToDisplay - bestSellingProducts.length;

        // Get remaining best selling products
        if (numRemainingProducts > 0) {
            try {
                const response = await fetch(`${productDetailServletEndpoint}?categoryIds=all&fields=all&sortBy=salesSort--salesOrg_preferredAvailability&startIndex=0&numResults=${numRemainingProducts}&app=${this.constants.appType}&countryCode=${countryCode}`);
                const responseBuffer = await response.arrayBuffer();
                const responseString = new TextDecoder('UTF-8').decode(responseBuffer);
                const responseJson = JSON.parse(responseString);
                responseJson.docs.forEach((product) => {
                    if (!this.constants.productSet.includes(product.catalogNumber)) {
                        bestSellingProducts.push({
                            title: product.names_value || product.title,
                            description: product.description || product.R_description,
                            imageUrl: product.picture_url || this.constants.defaultImage,
                            page: productDetailsPage + product.catalogNumber + '.html',
                        });
                        this.constants.productSet.push(product.catalogNumber);
                    }
                });
            } catch (error) {
                console.warn('Error fetching best selling products:', error);
            }
        }

        if (bestSellingProducts.length > this.constants.productsToDisplay) {
            bestSellingProducts.splice(this.constants.productsToDisplay);
        }
        return bestSellingProducts;
    }

    createProductElement = async (product) => {
        const productElement = this.elements.productTemplate.cloneNode(true);
        productElement.classList.remove(`${componentName}__product-template`);
        this.addTextContentOrRemove(productElement.querySelector(`.${componentName}__product-title`), product.title);
        this.addTextContentOrRemove(productElement.querySelector(`.${componentName}__product-description`), product.description);
        productElement.querySelector(`.${componentName}__product-image`).addEventListener('error', () => {
            productElement.querySelector(`.${componentName}__product-image`).src = this.constants.defaultImage;
        });
        if (product.picture_url) {
            productElement.querySelector(`.${componentName}__product-image`).src = product.picture_url.includes('/') ? product.picture_url : this.constants.productImagePrefix + product.picture_url;
        } else if (product.image) {
            productElement.querySelector(`.${componentName}__product-image`).src = product.image.includes('/') ? product.image : this.constants.productImagePrefix + product.image;
        } else if (product.imageUrl && !product.imageUrl.endsWith('.html')) {
            productElement.querySelector(`.${componentName}__product-image`).src = product.imageUrl;
        } else if (product.imageUrl && product.imageUrl.endsWith('.html')) {
            productElement.querySelector(`.${componentName}__product-image`).src = await this.getProductImage(`${window.location.origin}/en-us${product.imageUrl}`);
        } else {
            productElement.querySelector(`.${componentName}__product-image`).src = this.constants.defaultImage;
        }
        productElement.querySelector(`.${componentName}__product-image`).alt = product.title;
        const linkElement = productElement.querySelector(`.${componentName}__product-link`);
        if (linkElement) {
            linkElement.href = `/${this.constants.locale}${product.page}`;
            linkElement.ariaLabel = product.title;
        }
        return productElement;
    };

    getProductImage = async (productUrl) => {
        try {
            const response = await fetch(productUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'text/html; charset=UTF-8',
                },
            });
            const responseText = await response.text();
            const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
            const productImage = responseDocument.querySelector('img');
            return productImage ? productImage.src : this.constants.defaultImage;
        } catch (error) {
            console.warn('Error fetching product image:', error);
            return this.constants.defaultImage;
        }
    };

    addTextContentOrRemove = (element, textContent) => {
        if (textContent) {
            element.textContent += textContent;
        } else {
            element.remove();
        }
    };

    initDom = async () => {
        const { productResultsBasedOnViews, productCategoriesBasedOnViews } = this.getBasedOnViewsProducts();
        let productResultsBestSelling = [];
        const productResultsBestSellingBasedOnViews = await this.getBestSellingBasedOnViews();
        if (productResultsBestSellingBasedOnViews.length < this.constants.productsToDisplay) {
            const productResultsBestSellingAll = await this.getBestSellingProducts();
            productResultsBestSellingAll.splice((this.constants.productsToDisplay - productResultsBestSellingBasedOnViews.length));
            productResultsBestSelling = [...productResultsBestSellingBasedOnViews, ...productResultsBestSellingAll];
        } else {
            productResultsBestSelling = productResultsBestSellingBasedOnViews;
        }

        if (productResultsBasedOnViews.length > 0) {
            productResultsBasedOnViews.forEach(async (product) => {
                const productElement = await this.createProductElement(product);
                this.elements.basedOnViewsList.appendChild(productElement);
            });
        } else {
            this.elements.container.querySelector(`.${componentName}__content--based-on-views`).remove();
        }
        if (productResultsBestSelling.length > 0) {
            productResultsBestSelling.forEach(async (product) => {
                const productElement = await this.createProductElement(product);
                this.elements.bestSellingList.appendChild(productElement);
            });
        } else {
            this.elements.container.querySelector(`.${componentName}__content--best-selling`).remove();
        }
    };

    /**
     * Initialize Component
     */
    init = () => {
        this.initDom();
    };
}

registerComponent(`.${componentName}`, ProductRecommendations);
